(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["panta-card-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('panta-card-colors')) {
    customElements.define('panta-card-colors', class extends HTMLElement {
      connectedCallback() {
        this.onColorChange = this.onColorChange || this.syncSelection.bind(this);
        this.addEventListener('change', this.onColorChange);
        this.syncPresentation(this.querySelector('input:checked'));
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onColorChange);
      }

      syncPresentation(input) {
        if (!input) return;
        const card = this.closest('product-card');
        const template = this.querySelector(`template[data-color-presentation="${input.value}"]`);
        if (!card || !template) return;
        const price = template.content.querySelector('price-list');
        if (price) card.querySelector('price-list')?.replaceWith(price.cloneNode(true));
        const figure = card.querySelector('.product-card__figure');
        if (!figure) return;
        let badgeList = figure.querySelector(':scope > badge-list');
        badgeList?.querySelectorAll('on-sale-badge, sold-out-badge').forEach(badge => badge.remove());
        const badges = template.content.querySelectorAll('on-sale-badge, sold-out-badge');
        if (badges.length && !badgeList) {
          badgeList = document.createElement('badge-list');
          badgeList.className = 'badge-list badge-list--vertical';
          figure.prepend(badgeList);
        }
        for (const badge of badges) badgeList.append(badge.cloneNode(true));
        if (badgeList && !badgeList.children.length) badgeList.remove();
      }

      async syncSelection(event) {
        const input = event.target;
        if (!input.matches('input[type="radio"]') || !input.checked) return;
        // Handle these tiles here so the native asynchronous card handler cannot overwrite a newer selection.
        event.stopPropagation();
        const card = this.closest('product-card');
        if (!card) return;
        this.syncPresentation(input);
        const selectionVersion = this.selectionVersion = (this.selectionVersion || 0) + 1;
        const modal = card.querySelector('quick-buy-modal');
        if (modal && input.dataset.quickBuyHandle) {
          modal.setAttribute('handle', input.dataset.quickBuyHandle);
        }

        for (const link of card.querySelectorAll('.product-card__media, a.product-title')) {
          const url = new URL(input.dataset.productUrl || link.href, document.baseURI);
          if (input.dataset.variantId) url.searchParams.set('variant', input.dataset.variantId);
          link.href = `${url.pathname}${url.search}${url.hash}`;
        }

        const primary = card.querySelector('.product-card__image--primary');
        if (!primary || !input.dataset.variantMedia) return;
        const media = JSON.parse(input.dataset.variantMedia);
        const { createMediaImg } = await import('theme');
        if (selectionVersion !== this.selectionVersion || !this.isConnected) return;

        const image = createMediaImg(media, [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800], {
          class: primary.className,
          sizes: primary.sizes
        });
        image.alt = media.alt || card.querySelector('.product-title')?.textContent.trim() || '';
        const loaded = image.complete ? image.naturalWidth > 0 : await new Promise((resolve) => {
          image.addEventListener('load', () => resolve(true), { once: true });
          image.addEventListener('error', () => resolve(false), { once: true });
        });
        if (!loaded || selectionVersion !== this.selectionVersion || !this.isConnected) return;

        card.querySelector('.product-card__image--primary')?.replaceWith(image);
        const secondary = card.querySelector('.product-card__image--secondary');
        if (secondary) {
          const hoverImage = image.cloneNode(true);
          hoverImage.className = secondary.className;
          hoverImage.ariaHidden = 'true';
          secondary.replaceWith(hoverImage);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["panta-store-polish"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#newsletter-rabatt"]');
    if (!link) return;
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'TgJDPC']);
  });

  (() => {
    const bannerSelector = '[data-testid="klaviyo-form-VEA795"]';
    const observedBanners = new Set();
    let frame = 0;

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const resizeObserver = new ResizeObserver(schedule);

    function update() {
      frame = 0;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      const viewport = window.visualViewport;
      const top = viewport?.offsetTop || 0;
      const height = viewport?.height || window.innerHeight;
      const bottom = top + height;
      let offset = 0;
      const banners = new Set(document.querySelectorAll(bannerSelector));

      for (const banner of observedBanners) {
        if (!banners.has(banner)) {
          resizeObserver.unobserve(banner);
          observedBanners.delete(banner);
        }
      }
      for (const banner of banners) {
        if (!observedBanners.has(banner)) {
          resizeObserver.observe(banner);
          observedBanners.add(banner);
        }
        const rect = banner.getBoundingClientRect();
        const style = getComputedStyle(banner);
        const dialog = banner.closest('[role="dialog"]');
        const dialogStyle = dialog && getComputedStyle(dialog);
        const bottomAnchored = dialogStyle?.position === 'fixed' && dialogStyle.bottom !== 'auto';
        if (rect.width && rect.height && style.visibility !== 'hidden' && (bottomAnchored || rect.bottom >= bottom - 4) && rect.top < bottom && rect.bottom > top) {
          offset = Math.max(offset, Math.ceil(bottom - rect.top) + 12);
        }
      }
      for (const [name, value] of Object.entries({
        '--panta-cart-viewport-top': `${top}px`,
        '--panta-cart-viewport-height': `${height}px`,
        '--panta-cart-newsletter-offset': `${offset}px`
      })) {
        if (drawer.style.getPropertyValue(name) !== value) drawer.style.setProperty(name, value);
      }
    }

    const observer = new MutationObserver((records) => {
      if (records.some((record) => record.target.localName !== 'cart-drawer')) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    window.addEventListener('klaviyoForms', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('dialog:before-show', update, true);
    document.addEventListener('cart-drawer:refreshed', schedule);
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
